module.exports = __webpack_public_path__ + "static/media/accept.0b8d5cf9.png";